import store from "@/config/store"
import axios from "axios";
import config from "@/config"
import router from "@/config/router"
import $ from 'jquery'
import Vue from 'vue'
import VueCookies from "vue-cookies";

Vue.use(VueCookies)

const isLocal = process.env.NODE_ENV === "local"

const instance = axios.create({
    baseURL: config.API_HOST,
    timeout: isLocal ? 0 : 60000
})

const buildJsonParams = function(params) {
    let checkObj = $.extend(true, {}, params)
    let checkedKeys = Object.keys(checkObj).filter(
        (key) => key !== "page"  && !checkObj[key]
    )
    checkedKeys.forEach( function(key) {
        delete checkObj[key]
    })
    return checkObj
}

instance.interceptors.request.use(
    function (config) {
        // if(!config.url.includes('/refresh'))
        // Vue.prototype.$loading(true)

        config.withCredentials = true
        if(isLocal)
            console.log('AXIOS REQ:', config)
        return config
    },
    function (error) {
        console.log('[Error]AXIOS REQ:', error)
        return Promise.reject(error);
    }
)

instance.interceptors.response.use(
    function ({data, headers, config}) {
        Vue.prototype.$loading(false)
        if(isLocal)
            console.log('AXIOS RES:', data, headers) // for dev
        switch(data.code){
            case 1000:
                return data.content
            case 2014:
                if (!window.location.pathname.includes('/login')) {
                    Vue.prototype.$notify.error("Error[" + data.code + "]", data.content || data.message)
                    store.commit('removeUser')
                    router.push('/login?to=' + 'window.location.pathname').then(() => null)
                }
                return Promise.reject(data)
            default:
                // silent 요청(백그라운드 폴링 등)은 토스트 억제 — 일시적 timeout 이 UI 를 도배하지 않게
                if (!config?.silent)
                    Vue.prototype.$notify.error("Error[" + data.code + "]", data.content || data.message)
                return Promise.reject(data)
        }
    },

    function (error) {
        console.log('[Error]AXIOS RES:', error)
        Vue.prototype.$loading(false)
        if (!error.config?.silent && !window.location.pathname.includes('/login')) {
            Vue.prototype.$notify.error('Error', error?.toString()?.includes('timeout') ? 'Request Timeout' : 'Unknown Error')
        }
        return Promise.reject(error)
    }
)

export default instance;

